import {
  IcoBranch16,
  IcoChart16,
  IcoChecklist16,
  IcoClock16,
  IcoFilter16,
  IcoFlag16,
  IcoIdCard16,
  IcoInfo16,
  IcoLayer0116,
  IcoLongText16,
  type Icon,
  IcoQuoteLeft16,
  IcoShuffle16,
  IcoTable16,
} from '@onefootprint/icons';
import type { ReportSectionKind } from './report-outline';

type KindGroup = 'narrative' | 'evidence' | 'verdict';

type KindMeta = { group: KindGroup; icon: Icon };

const SECTION_KINDS: Record<ReportSectionKind, KindMeta> = {
  custom: { group: 'narrative', icon: IcoLayer0116 },
  narrative: { group: 'narrative', icon: IcoLongText16 },
  callout: { group: 'narrative', icon: IcoInfo16 },
  quote: { group: 'narrative', icon: IcoQuoteLeft16 },
  record: { group: 'evidence', icon: IcoIdCard16 },
  stat: { group: 'evidence', icon: IcoChart16 },
  'data-view': { group: 'evidence', icon: IcoTable16 },
  checklist: { group: 'evidence', icon: IcoChecklist16 },
  timeline: { group: 'evidence', icon: IcoClock16 },
  compare: { group: 'evidence', icon: IcoShuffle16 },
  cluster: { group: 'evidence', icon: IcoBranch16 },
  funnel: { group: 'evidence', icon: IcoFilter16 },
  decision: { group: 'verdict', icon: IcoFlag16 },
};

const KIND_GROUPS: KindGroup[] = ['narrative', 'evidence', 'verdict'];

const KINDS_IN_GROUP = (group: KindGroup): ReportSectionKind[] =>
  (Object.keys(SECTION_KINDS) as ReportSectionKind[]).filter(kind => SECTION_KINDS[kind].group === group);

export type { KindGroup };
export { KIND_GROUPS, KINDS_IN_GROUP, SECTION_KINDS };
